/**
 * The Security Center's page list: the overview, then every page, the
 * current one marked. Desktop only; phones get the list under each page.
 */
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SECURITY_CENTER, SECURITY_BASE_PATH } from '@/content/security';
import SecurityIcon from './SecurityIcon';

const item = (active) => cn(
  'flex items-center gap-2.5 rounded-lg px-2.5 py-2 transition-colors',
  active ? 'bg-white/[0.06] text-white' : 'text-white/60 hover:bg-white/[0.04] hover:text-white',
);

export default function SecuritySidebar({ slug }) {
  return (
    <nav aria-label="Security pages" className="text-[14px]">
      <p className="mb-3 text-[11px] uppercase tracking-[0.18em] text-white/40">Security</p>
      <ul className="space-y-0.5">
        <li>
          <Link to={SECURITY_BASE_PATH} aria-current={!slug ? 'page' : undefined} className={item(!slug)}>
            <Shield className="h-4 w-4 flex-shrink-0 text-white/50" strokeWidth={1.5} aria-hidden />
            <span className="min-w-0 truncate">Overview</span>
          </Link>
        </li>
        {SECURITY_CENTER.pages.map((p) => (
          <li key={p.slug}>
            <Link to={p.path} aria-current={p.slug === slug ? 'page' : undefined} className={item(p.slug === slug)}>
              <SecurityIcon name={p.icon} className="h-4 w-4 flex-shrink-0 text-white/50" />
              <span className="min-w-0 truncate">{p.navTitle}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
SecuritySidebar.propTypes = { slug: PropTypes.string };
